// Generated file : do not modify
export enum Synchro98ServiceTypes
{
  NONE = 0,
  ESSENTIAL,
  ASSISTED,
  PREMIUM
};

export enum Synchro98SalarieTypes
{
  NONE = 0,
  MIXTED,
  INTERMITTENTS
};

export enum Synchro98NbPaiesTypes
{
  NONE = 0,
  LOW,
  MEDIUM,
  HIGHT
};

export enum Synchro98ProjetGroupBys
{
  NONE = 0,
  MONTH,
  YEAR
};

import { MetaValue } from '@/extend/classes/MetaAttrib';
import Owner from '@/extend/classes/Owner';
import { LoginAnswer } from '@/extend/classes/Session';
import { ConnectionParamModes } from '@/generated/classes/Session';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import User from '@/extend/classes/User';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Synchronisation CI98
export class ProgressSynchro98 {
  // Libellé
  public label: string;
  // Nombre
  public current: number;
  // Total
  public total: number;

  constructor() {
    this.label = '';
    this.current = 0;
    this.total = 0;
  }
}

export default class Synchro98 extends User {
  // Token de session
  public token: string;
  // Client authentifié
  public authentified: boolean;
  // Code de validation
  public code: string;
  // Statut des synchro
  public progresses: ProgressSynchro98[];
  // Synchro documents en cours
  public synchroDocuments: boolean;
  // Synchro achevée
  public synchroCompleted: boolean;
  // Etablissement
  public etablissementId: number;
  // Type de service
  public serviceType: Synchro98ServiceTypes;
  // Type de salariés
  public salarieType: Synchro98SalarieTypes;
  // Nombre de paies type
  public nbPaiesType: Synchro98NbPaiesTypes;
  // Regroupement périodique
  public projetGroupBy: Synchro98ProjetGroupBys;
  // Refresh CI98
  public refresh: boolean;
  // Identifiant mail CI98
  public identMailId: number | null;
  // Identifiant numéro CI98
  public identNumeroId: number | null;
  // Identifiant
  public identifiant: string;
  // Masque du profil utilisateur
  public profil: number;
  // Masque du profil utilisateur
  public currentProfil: number;
  // Première connexion
  public firstConnexion: boolean;
  // Compte désactivé
  public disabled: boolean;
  // Numéro de client CI-98
  public client98: number;
  // Dialog migration CI-98
  public dialog98: string;
  // Mode de connexion
  public connectionMode: ConnectionParamModes;
  // Se souvenir de moi
  public rememberMe: boolean;
  // Mot de passe défini
  public hasPassword: boolean;
  // Module dont le wizard a été affiché
  public modules: string[];
  // Date dont le CGU a été accepté
  public cguAcceptedAt: Date | null;
  // Méta-attributs
  public metaValues: MetaValue[];
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Client
  public clientId: number;
  // Type de notification
  public notifDefType: NotifDefTypes;
  // Identifiant unique
  public id: number;
  // Civilité
  public civiliteId: number;
  // Prénom
  public prenom: string;
  // Nom
  public nom: string;
  // Qualité
  public qualiteId: number;
  // Adresse mail
  public mailId: number;
  // Adresse mail
  public mail: string;
  // Numéro de téléphone
  public numeroId: number;
  // Téléphone
  public numero: string;
  // Adresse postale
  public adresseId: number;
  // Vérification demandée au serveur
  public verify: boolean;
  // Validation effectué par le serveur
  public valid: boolean;
  // Contact associé à un utilisateur
  public isUser: boolean;
  // Recipient id edusign
  public eduSignRecipientId: string;
  // Objet à l'origine de la requête
  public owner: Owner;

  constructor() {
    super();
    this.token = '';
    this.authentified = false;
    this.code = '';
    this.progresses = [];
    this.synchroDocuments = false;
    this.synchroCompleted = false;
    this.etablissementId = 0;
    this.serviceType = Synchro98ServiceTypes.NONE;
    this.salarieType = Synchro98SalarieTypes.NONE;
    this.nbPaiesType = Synchro98NbPaiesTypes.NONE;
    this.projetGroupBy = Synchro98ProjetGroupBys.NONE;
    this.refresh = false;
    this.identMailId = null;
    this.identNumeroId = null;
    this.identifiant = '';
    this.profil = 0;
    this.currentProfil = 0;
    this.firstConnexion = false;
    this.disabled = false;
    this.client98 = 0;
    this.dialog98 = '';
    this.connectionMode = ConnectionParamModes.NONE;
    this.rememberMe = false;
    this.hasPassword = false;
    this.modules = [];
    this.cguAcceptedAt = null;
    this.metaValues = [];
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.clientId = 0;
    this.notifDefType = NotifDefTypes.NONE;
    this.id = 0;
    this.civiliteId = 0;
    this.prenom = '';
    this.nom = '';
    this.qualiteId = 0;
    this.mailId = 0;
    this.mail = '';
    this.numeroId = 0;
    this.numero = '';
    this.adresseId = 0;
    this.verify = false;
    this.valid = false;
    this.isUser = false;
    this.eduSignRecipientId = '';
    this.owner = new Owner();
  }

  public static fromJson (obj: Synchro98): Synchro98 {
    const newSynchro98: Synchro98 = new Synchro98();
    newSynchro98.token = obj.token;
    newSynchro98.authentified = obj.authentified;
    newSynchro98.code = obj.code;
    newSynchro98.progresses = JSON.parse(JSON.stringify(obj.progresses));
    newSynchro98.synchroDocuments = obj.synchroDocuments;
    newSynchro98.synchroCompleted = obj.synchroCompleted;
    newSynchro98.etablissementId = obj.etablissementId;
    newSynchro98.serviceType = obj.serviceType;
    newSynchro98.salarieType = obj.salarieType;
    newSynchro98.nbPaiesType = obj.nbPaiesType;
    newSynchro98.projetGroupBy = obj.projetGroupBy;
    newSynchro98.refresh = obj.refresh;
    newSynchro98.identMailId = obj.identMailId;
    newSynchro98.identNumeroId = obj.identNumeroId;
    newSynchro98.identifiant = obj.identifiant;
    newSynchro98.profil = obj.profil;
    newSynchro98.currentProfil = obj.currentProfil;
    newSynchro98.firstConnexion = obj.firstConnexion;
    newSynchro98.disabled = obj.disabled;
    newSynchro98.client98 = obj.client98;
    newSynchro98.dialog98 = obj.dialog98;
    newSynchro98.connectionMode = obj.connectionMode;
    newSynchro98.rememberMe = obj.rememberMe;
    newSynchro98.hasPassword = obj.hasPassword;
    newSynchro98.modules = JSON.parse(JSON.stringify(obj.modules));
    newSynchro98.cguAcceptedAt = obj.cguAcceptedAt ? new Date(obj.cguAcceptedAt) : null;
    newSynchro98.metaValues = JSON.parse(JSON.stringify(obj.metaValues));
    newSynchro98.createId = obj.createId;
    newSynchro98.failed = obj.failed;
    newSynchro98.canUpdate = obj.canUpdate;
    newSynchro98.canDelete = obj.canDelete;
    newSynchro98.display = obj.display;
    newSynchro98.clientId = obj.clientId;
    newSynchro98.notifDefType = obj.notifDefType;
    newSynchro98.id = obj.id;
    newSynchro98.civiliteId = obj.civiliteId;
    newSynchro98.prenom = obj.prenom;
    newSynchro98.nom = obj.nom;
    newSynchro98.qualiteId = obj.qualiteId;
    newSynchro98.mailId = obj.mailId;
    newSynchro98.mail = obj.mail;
    newSynchro98.numeroId = obj.numeroId;
    newSynchro98.numero = obj.numero;
    newSynchro98.adresseId = obj.adresseId;
    newSynchro98.verify = obj.verify;
    newSynchro98.valid = obj.valid;
    newSynchro98.isUser = obj.isUser;
    newSynchro98.eduSignRecipientId = obj.eduSignRecipientId;
    newSynchro98.owner = JSON.parse(JSON.stringify(obj.owner));
    return newSynchro98;
  }

  public toJsonSynchro98 (): string {
    const json = {
      token: this.token,
      authentified: this.authentified,
      code: this.code,
      progresses: this.progresses,
      synchroDocuments: this.synchroDocuments,
      synchroCompleted: this.synchroCompleted,
      etablissementId: this.etablissementId,
      serviceType: this.serviceType,
      salarieType: this.salarieType,
      nbPaiesType: this.nbPaiesType,
      projetGroupBy: this.projetGroupBy,
      refresh: this.refresh,
      identMailId: this.identMailId,
      identNumeroId: this.identNumeroId,
      identifiant: this.identifiant,
      profil: this.profil,
      currentProfil: this.currentProfil,
      firstConnexion: this.firstConnexion,
      disabled: this.disabled,
      client98: this.client98,
      dialog98: this.dialog98,
      connectionMode: this.connectionMode,
      rememberMe: this.rememberMe,
      hasPassword: this.hasPassword,
      modules: this.modules,
      cguAcceptedAt: this.cguAcceptedAt ? new Date (this.cguAcceptedAt).toString() : this.cguAcceptedAt,
      metaValues: this.metaValues,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
      civiliteId: this.civiliteId,
      prenom: this.prenom,
      nom: this.nom,
      qualiteId: this.qualiteId,
      mailId: this.mailId,
      mail: this.mail,
      numeroId: this.numeroId,
      numero: this.numero,
      adresseId: this.adresseId,
      verify: this.verify,
      valid: this.valid,
      isUser: this.isUser,
      eduSignRecipientId: this.eduSignRecipientId,
    }
    return JSON.stringify(json);
  }

  public fromSynchro98 (obj: Synchro98): void {
    this.token = obj.token;
    this.authentified = obj.authentified;
    this.code = obj.code;
    this.progresses = obj.progresses;
    this.synchroDocuments = obj.synchroDocuments;
    this.synchroCompleted = obj.synchroCompleted;
    this.etablissementId = obj.etablissementId;
    this.serviceType = obj.serviceType;
    this.salarieType = obj.salarieType;
    this.nbPaiesType = obj.nbPaiesType;
    this.projetGroupBy = obj.projetGroupBy;
    this.refresh = obj.refresh;
    this.identMailId = obj.identMailId;
    this.identNumeroId = obj.identNumeroId;
    this.identifiant = obj.identifiant;
    this.profil = obj.profil;
    this.currentProfil = obj.currentProfil;
    this.firstConnexion = obj.firstConnexion;
    this.disabled = obj.disabled;
    this.client98 = obj.client98;
    this.dialog98 = obj.dialog98;
    this.connectionMode = obj.connectionMode;
    this.rememberMe = obj.rememberMe;
    this.hasPassword = obj.hasPassword;
    this.modules = obj.modules;
    this.cguAcceptedAt = obj.cguAcceptedAt;
    this.metaValues = obj.metaValues;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.clientId = obj.clientId;
    this.notifDefType = obj.notifDefType;
    this.id = obj.id;
    this.civiliteId = obj.civiliteId;
    this.prenom = obj.prenom;
    this.nom = obj.nom;
    this.qualiteId = obj.qualiteId;
    this.mailId = obj.mailId;
    this.mail = obj.mail;
    this.numeroId = obj.numeroId;
    this.numero = obj.numero;
    this.adresseId = obj.adresseId;
    this.verify = obj.verify;
    this.valid = obj.valid;
    this.isUser = obj.isUser;
    this.eduSignRecipientId = obj.eduSignRecipientId;
    this.owner = obj.owner;
  }

  public compareSynchro98 (value: Synchro98): boolean {
    return (this.toJsonSynchro98() == value.toJsonSynchro98());
  }

  public cloneSynchro98 (): Synchro98 {
    return Synchro98.fromJson(this);
  }

  public static getData (id: string): Promise<Synchro98> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/synchro98/getData/' + id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Synchro98.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static import (synchro98: Synchro98): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/synchro98/import', synchro98, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static resynch (etablissementId: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/synchro98/resynch/' + etablissementId, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static acceptCgu (synchro98: Synchro98): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/synchro98/acceptCgu', synchro98, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static setProjects (synchro98: Synchro98): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/synchro98/setProjects', synchro98, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static setSubscription (synchro98: Synchro98): Promise<LoginAnswer> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/synchro98/setSubscription', synchro98, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static unsetSuggested (etablissementId: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/synchro98/unsetSuggested/' + etablissementId, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static showReport (synchro98: Synchro98): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/synchro98/showReport', synchro98, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(synchro98s: Synchro98[]) {
    synchro98s.forEach((item) => {
      item.cguAcceptedAt = item.cguAcceptedAt ? new Date(item.cguAcceptedAt) : item.cguAcceptedAt;
    })
  }
}
